// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BooksWithUsers from "../../components/dashboard/BooksWithUsers";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BooksWithUsers />
    </DashboardLayout>
  );
}
